'use es6';

export const OUTLOOK365 = 'o365';